// extracted by mini-css-extract-plugin
module.exports = {"CategorySwitch":"category-switch_CategorySwitch__1MAHt","active":"category-switch_active__32uqz"};